import { useIntl } from 'react-intl';

import type { RoutingSettings } from '../model/routingSettings.ts';
import type { SmartRouteResult } from '../service/smartRoute.ts';
import { EvChargingPreview } from './EvChargingPreview.tsx';

type Props = {
    result: SmartRouteResult;
    routingSettings: RoutingSettings;
};

export const SmartRouteSummary = ({ result, routingSettings }: Props) => {
    const intl = useIntl();
    return (
        <output className='alert alert-success margin-bottom-10 flex-shrink-0'>
            {intl.formatMessage(
                { id: 'intl-msg:ordercom-cloud-frontend.smart-route.summary' },
                {
                    distance: intl.formatNumber(result.distance / 1000, {
                        maximumFractionDigits: 1,
                    }),
                    hours: Math.floor(Math.ceil(result.duration / 60) / 60),
                    minutes: Math.ceil(result.duration / 60) % 60,
                }
            )}
            <div className='text-size-12 margin-top-5'>
                {intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.smart-route.disclaimer',
                })}
            </div>
            {result.hasWarnings && (
                <div className='text-color-warning margin-top-5'>
                    {intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.smart-route.warning',
                    })}
                </div>
            )}
            {result.chargingStops && (
                <EvChargingPreview
                    stops={result.chargingStops}
                    settings={routingSettings}
                    chargingDuration={result.chargingDuration}
                />
            )}
            {result.vehicleCost !== undefined && (
                <div className='margin-top-10'>
                    <strong>
                        {intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.routing-settings.costs',
                        })}
                    </strong>
                    <div>
                        {intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.routing-settings.vehicleCost',
                        })}
                        :{' '}
                        {intl.formatNumber(result.vehicleCost, {
                            style: 'currency',
                            currency: 'EUR',
                        })}
                    </div>
                    <div>
                        {intl.formatMessage({
                            id: 'intl-msg:ordercom-cloud-frontend.routing-settings.tolls',
                        })}
                        :{' '}
                        {result.tollCost === undefined
                            ? intl.formatMessage({
                                  id: 'intl-msg:ordercom-cloud-frontend.routing-settings.unavailable',
                              })
                            : intl.formatNumber(result.tollCost, {
                                  style: 'currency',
                                  currency: 'EUR',
                              })}
                    </div>
                    {result.tollCost !== undefined && (
                        <strong>
                            {intl.formatMessage({
                                id: 'intl-msg:ordercom-cloud-frontend.routing-settings.total',
                            })}
                            :{' '}
                            {intl.formatNumber(result.vehicleCost + result.tollCost, {
                                style: 'currency',
                                currency: 'EUR',
                            })}
                        </strong>
                    )}
                </div>
            )}
        </output>
    );
};
